<script>
export default {
    name: "PriceSchemeForm"
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="md:w-1/4 sm:w-full p-tiny">
            <label class="label-control" for="grid-name">Scheme:</label>
            <input type="text" class="input-control input-sm text-xs" id="grid-name">
        </div>
        <div class="md:w-1/4 sm:w-full p-tiny">
            <label class="label-control" for="grid-description">Description:</label>
            <input type="text" class="input-control input-sm text-xs" id="grid-description">
        </div>
        <div class="md:w-1/12 sm:w-full p-tiny mt-4">
            <label for="is_default" class="label-control">Is Default
                <input type="checkbox" id="is_default">
            </label>
        </div>
        <div class="md:w-1/12 sm:w-full p-tiny mt-4">
            <label for="grid-active" class="label-control">Active
                <input type="checkbox" id="grid-active">
            </label>
        </div>
        <div class="md:w-1/12 sm:w-full p-tiny mt-2">
            <button class="btn-info btn-sm text-xs rounded"><i class="fa fa-save"></i> Save</button>
        </div>
    </div>
</template>
